import styled from "styled-components"

export const useDebugDB = false

export function writeToLocalStorage(answers: Answers, send?: boolean) {
  if (send) {
    answers.send = true
  }
  localStorage.setItem('sexumfrage_2024', JSON.stringify(answers))
}

export function readLocalStorage() {
  const answers = localStorage.getItem('sexumfrage_2024')
  if (answers) {
    return JSON.parse(answers)
  }
  return null
}

export const ResetButton = ({ lang }: { lang: 'de' | 'fr' }) => {
  return (
    <Button
      style={{ position: 'relative', zIndex: '3000' }}
      onClick={() => {
        localStorage.removeItem('sexumfrage_2024')
        localStorage.removeItem('sexumfrage2024_consentAccepted')
        // var data
        // if (localStorage.getItem('sexumfrage_2024')) {
        //   data = JSON.parse(localStorage.getItem('sexumfrage_2024')||'{}')
        // }
        // if (data.send) {
        //   delete data.send
        //   writeToLocalStorage(data)
        // }
        localStorage.removeItem('sexumfrageID')
        window.location.reload()
      }}
    >
      {lang === 'fr'
        ? 'Réinitialiser toutes les réponses'
        : 'Alle Antworten zurücksetzen'}
    </Button>
  )
}


const Button = styled.button`
  background-color: var(--purple-main);
  color: white;
  border: none;
  padding: 10px 20px;
  font-size: 15px;
  border-radius: 5px;
  cursor: pointer;
  margin: 0.5rem;
  margin-top: 15px;
  &:hover {
    background-color: #fff;
    color: var(--purple-main);
  }
`